import type { ReactNode } from 'react';
import { useAuthStore } from '@/stores/auth.store';
import { useLogout } from '@/features/auth/use-auth';

/**
 * Gatea TODO el console: solo operadores (User.isPlatformAdmin). Si un usuario
 * de tenant entra, muestra "acceso denegado" + cerrar sesion (sin redirect-loop).
 */
export function RequirePlatformAdmin({ children }: { children: ReactNode }): JSX.Element | null {
  const user = useAuthStore((s) => s.user);
  const logout = useLogout();

  if (!user) return null; // RequireAuth se encarga
  if (!user.isPlatformAdmin) {
    return (
      <div className="min-h-screen grid place-items-center bg-background p-6">
        <div className="max-w-sm text-center space-y-3">
          <h1 className="text-lg font-semibold">Acceso solo para operadores</h1>
          <p className="text-sm text-muted-foreground">
            Tu cuenta no tiene permisos de operador de plataforma. Para gestionar tu empresa, usa la
            aplicacion principal.
          </p>
          <button
            type="button"
            onClick={() => logout.mutate()}
            className="inline-flex items-center justify-center rounded-full bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
          >
            Cerrar sesion
          </button>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
